import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ConstitutionTicket } from '../domain/models/constitution-ticket.model';
import { ConstitutionTicketsRepository } from '../domain/repository/constitution-tickets.repository';
import { CONSTITUTION_TICKETS_REPOSITORY } from './modal-all-tickets.tokens';

@Injectable()
export class GetAllTicketsByRecordIdConstitutionUseCase {
  constructor(@Inject(CONSTITUTION_TICKETS_REPOSITORY) private readonly repository: ConstitutionTicketsRepository) { }

  execute(constitutionRecordId: string): Observable<ConstitutionTicket[]> {
    if (!constitutionRecordId) return of([]);
    return this.repository.getAllTicketsByRecordIdConstitution(constitutionRecordId);
  }
}
